import Button from '../../../components/CustomButtons/ButtonTS';
import { NavLink } from 'react-router-dom';
import React from 'react';
import Assignment from "@material-ui/icons/Assignment";
import { INode } from '../../helpers/interfaces';
import Tooltip from "@material-ui/core/Tooltip";

interface ILogsIconProps {
	show: boolean;
	nodeId: number;
	systemId: number;
}

export const LogsIcon = (props: ILogsIconProps) => {
	const { show, nodeId, systemId } = props;
	if (!show) {
		return null;
	}
	return (
	    <NavLink to={`/logs?system=${systemId}&node=${nodeId}`}>
            <Tooltip title="Go to logs">
	            <div>
                    <Button color='info' simple justIcon data-testid='logsIcon'>
                        <Assignment />
                    </Button>
                </div>
            </Tooltip>
        </NavLink>
	);
};

export default LogsIcon;
